import { useMutation, useQuery, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { brandedAppsBuilderUI } from "@/react/helpers/urlHelpers/internalApi/brandedAppsBuilderUI";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { useToast } from "@circle-react-shared/uikit/ToastV2";

interface WelcomeSpaceResponse {
  welcome_data: {
    spaces: {
      new_member_space_id: number | null;
      regular_member_space_id: number | null;
    };
    screens: {
      new_member_screen_id: string | null;
      regular_member_screen_id: string | null;
    };
  };
}

const QUERY_KEY = "welcome-data";

export type WelcomeDataPutPayload = WelcomeSpaceResponse;

export const useWelcomeDataApi = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery<WelcomeSpaceResponse, ApiError>({
    queryKey: [QUERY_KEY],
    queryFn: () => reactQueryGet(brandedAppsBuilderUI.welcomeData.get()),
  });

  const { mutateAsync: updateWelcomeSpaces } = useMutation({
    mutationFn: (payload: WelcomeDataPutPayload) =>
      reactQueryPut(brandedAppsBuilderUI.welcomeData.put(), payload),
    onSuccess: data => {
      queryClient.setQueryData([QUERY_KEY], data);
      toast.success(
        t("settings_nav_v3.branded_apps_dashboard.welcome_space.save.success"),
      );
    },
    onError: () => {
      toast.error(
        t("settings_nav_v3.branded_apps_dashboard.welcome_space.save.error"),
      );
    },
  });

  return { data, isLoading, error, updateWelcomeSpaces };
};
